/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { PROJECT_TYPES } from '@modules/ui-types/projects'
import RoutablePage from '@modules/routing/RoutablePage'
import Feature from '@modules/utils/feature'

import { isFeatureActivated } from '@/store' // eslint-disable-line import/no-restricted-paths

import ProjectPage from './ProjectPage'
import ProjectsPage from './ProjectsPage'
import ProjectNetworkSecurityPage from './ProjectNetworkSecurityPage'

import type { RouteObject } from 'react-router-dom'

export default function getProjectRoutes(): RouteObject[] {
  return [
    {
      path: 'projects',
      children: [
        {
          index: true,
          element: (
            <RoutablePage title='Projects'>
              <ProjectsPage />
            </RoutablePage>
          ),
        },
        ...PROJECT_TYPES.map<RouteObject>((projectType) => ({
          path: `${projectType}/:projectId`,
          children: [
            {
              index: true,
              element: (
                <RoutablePage title='Project'>
                  <ProjectPage projectType={projectType} />
                </RoutablePage>
              ),
            },
            ...(isFeatureActivated(Feature.networkSecurity)
              ? [
                  {
                    path: 'network-security',
                    element: (
                      <RoutablePage title='Network security'>
                        <ProjectNetworkSecurityPage projectType={projectType} />
                      </RoutablePage>
                    ),
                  },
                ]
              : []),
          ],
        })),
      ],
    },
  ]
}
